module.exports = __webpack_public_path__ + "img/customer_qrcode.1866d424.png";